import * as React from 'react';

import {LoadingPage} from 'shells/loading-page/loading-page';
import {SpacerGroup} from 'shells/spacer/spacer-group';
import {UppercaseLabel} from 'shells/typography/uppercase-label';

import type {Audience as AudienceFragment} from 'nutshell-graphql-types';

import type {ReportURLParams} from '../../reports/report-types';

import {updateSearchWithNewFilter} from '../utils';

import {AudienceEngagementStats} from './engagement/audience-engagement-stats';
import {AudienceLatestOutreach} from './latest-outreach/audience-latest-outreach';
import {AudienceMembershipStats} from './membership/audience-membership-stats';
import {AudienceMembershipReport} from './reports/audience-membership-report';

import styles from './audience-page-info.module.css';

type Props = {
    audience: AudienceFragment | null | undefined;
    onParamChange: (arg1: any, arg2: boolean) => any;
    onParamPush: (arg1: any, arg2: boolean) => any;
    urlParams: ReportURLParams<'contacts'>;
    isLoading: boolean;
};

export function AudiencePageInfo(props: Props) {
    if (!props.audience) {
        return <LoadingPage />;
    }

    return (
        <div>
            <SpacerGroup mb={32}>
                <div className='mb-8'>
                    <UppercaseLabel>Current membership</UppercaseLabel>
                </div>
                <div className={styles['membership-container']}>
                    <AudienceMembershipStats
                        audienceId={props.audience.id}
                        onClickStat={(filterKey: string) => {
                            if (props.audience) {
                                const newSearch = updateSearchWithNewFilter(
                                    filterKey,
                                    props.audience.id,
                                    location.search,
                                    ['subscribedAudiences', 'unsubscribedAudiences', 'audiences']
                                );

                                // This is the relative path needed for the Link to work
                                return `members?${newSearch}`;
                            } else {
                                return '';
                            }
                        }}
                    />
                    <AudienceMembershipReport
                        audience={props.audience}
                        urlParams={props.urlParams}
                        onParamChange={props.onParamChange}
                        onParamPush={props.onParamPush}
                    />
                </div>
            </SpacerGroup>
            <SpacerGroup mb={32}>
                <div className='mb-8'>
                    <UppercaseLabel>Engagement</UppercaseLabel>
                </div>
                <div className={styles['engagement-container']}>
                    <AudienceEngagementStats audienceId={props.audience.id} />
                </div>
            </SpacerGroup>
            <div>
                <div className='mb-8'>
                    <UppercaseLabel>Latest outreach</UppercaseLabel>
                </div>
                {/* @ts-expect-error */}
                <AudienceLatestOutreach audience={props.audience} isLoading={props.isLoading} />
            </div>
        </div>
    );
}
